import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { DetailsPaginationStyles } from '@dealstack/frontend/shared/components/DetailsPagination/DetailsPagination.styles.tsx';
import { ActionIcon, Text } from '@mantine/core';

interface Props {
	/** What is being stepped through, e.g. "Accounts". */
	label: string;
	/** Position within the set, e.g. "7 of 8". Formatted by the caller. */
	counter: string;
	prevDisabled: boolean;
	nextDisabled: boolean;
	onPrev: () => void;
	onNext: () => void;
	dataTestId?: string;
}

/**
 * Prev/next stepper for a detail page, showing where the open record sits in the list it
 * was opened from. Presentational: pair it with `useDetailsPagination` for the paths.
 */
export const DetailsPagination = ({
	label,
	counter,
	prevDisabled,
	nextDisabled,
	onPrev,
	onNext,
	dataTestId,
}: Props) => (
	<DetailsPaginationStyles data-testid={dataTestId}>
		<ActionIcon
			variant="outline"
			color="gray.2"
			onClick={onPrev}
			className={`pagination-button ${prevDisabled ? 'disabled' : ''}`}
		>
			<Icon variant="caret-left" size="md" color="black" />
		</ActionIcon>

		<div className="text-container">
			<Text fz={12} c="dark.9">
				{label}
			</Text>

			<Text fz={12} fw={600} c="dark.9">
				{counter}
			</Text>
		</div>

		<ActionIcon
			variant="outline"
			color="gray.2"
			onClick={onNext}
			className={`pagination-button pagination-button-next ${nextDisabled ? 'disabled' : ''}`}
		>
			<Icon variant="caret-right" size="md" color="black" />
		</ActionIcon>
	</DetailsPaginationStyles>
);
